// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadInput_button__3LW3p","active":"UploadInput_active__2EE6c","input":"UploadInput_input__3Tn20","icon":"UploadInput_icon__2-3LS"};